
    import { GOOGLE_ANALYTICS_ID } from './src/configs/ANALYTICS';


    /**
     * Google Analytics
     */

    const script = document.createElement('script');
    script.async = true;
    script.src = `https://www.googletagmanager.com/gtag/js?id=${GOOGLE_ANALYTICS_ID}`;
    document.head.appendChild(script);

    window.dataLayer = window.dataLayer || [];

    /**
     * @global
     * @function window.gtag
     */
    function gtag() { dataLayer.push(arguments); }

    gtag('js', new Date());
    gtag('config', GOOGLE_ANALYTICS_ID, {
      cookie_flags: 'SameSite=None;Secure'
    });
  